<ng-container *ngIf="PROJECT_STATUS[this.result_status]">
  <div class="flex items-center space-x-1.5 {{PROJECT_STATUS[this.result_status]['color']}}">
    <svg-icon key="circle-fill" fontSize="12px" ></svg-icon>
    <span>{{PROJECT_STATUS[this.result_status]['key'] | titlecase}}</span>
  </div>
</ng-container>
